import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { jsParse, jsTransform } from './parser';
// --- Placeholder for Rust-specific logic ---
// You need to implement the equivalent of the Rust parser::parse function in JavaScript.
// This function should take a string (a line of input) and return a number (f64 equivalent)
// or NaN if parsing fails or the line should not be included in the total.



const Calculator = () => {
  const { t } = useTranslation();
  // State variables corresponding to the Rust Model struct
  const [inputText, setInputText] = useState("");
  const [outputText, setOutputText] = useState("");
  const [total, setTotal] = useState(0.0);

  // Use useEffect to perform calculations when the input text changes
  // This replaces the logic found in the Yew 'update' method
  useEffect(() => {
    let currentTotal = 0.0;
    let currentOutput = "";

    const lines = inputText.split('\n');

    for (const line of lines) {
      // Call your JavaScript parsing function
      const parsedValue = jsParse(line);

      // Check if the parsed value is a valid number (not NaN) before adding to total
      if (!isNaN(parsedValue)) {
        currentTotal += parsedValue;
      }

      // Format the parsed value using your JavaScript transform function
      currentOutput += jsTransform(parsedValue) + "\n";
    }

    // Update the state with the calculated results
    setTotal(currentTotal);
    setOutputText(currentOutput.trimEnd()); // Remove the last newline character
  }, [inputText]); // Dependency array: this effect runs whenever inputText changes



  const textareaRef = useRef(null);

  const handleTextAreahight = (event) => {
    const textarea = textareaRef.current;
    if (textarea) {
      textarea.style.height = "auto"; // Reset height for shrinking
      textarea.style.height = textarea.scrollHeight + "px"; // Set to content height
    }
  };



  // Handler for the textarea input changes
  const handleInputChange = (event) => {
    handleTextAreahight(event)
    // Update the inputText state. The useEffect hook will react to this change
    // and trigger the calculation.
    setInputText(event.target.value);
  };

  // Split the output text into an array of lines for rendering
  const outputLines = outputText.split('\n');

  return (
    <div className="main">
        <h2>{t('calculator.title')}</h2>
      <br />
      <div role="group" style={{gap: "10px"}}>
        {/* Textarea input */}
        <textarea
          autoFocus
          value={inputText} // Make it a controlled component
          onChange={handleInputChange} // Handle input changes
          style={{ resize: 'none', textAlign: "right", padding: "10px" }} // Inline style for resize
          data-gramm="false" // Prevent Grammarly issues
          placeholder={t('calculator.input_placeholder')}
        ></textarea>
        <div
          style={{
            width: "20%",
            padding: "10px",
            marginRight: "auto",

            // border: '2px dashed black',
            justifyItems: "right"
          }}>
          {/* Render output lines */}
          {outputLines.map((line, index) => (
            // Using index as key is okay here as items are static after split
            <div key={index}>{Math.round(line*1000)/1000 || ''}</div>
          ))}
          <p >{t('calculator.total_label')} {Math.round(jsTransform(total)*1000)/1000}</p>
        </div>
        {/* Display total */}
      </div>
    </div>

  );
};

export default Calculator;